import React, { useEffect, useState } from "react";
import { FaGraduationCap, FaUsers } from "react-icons/fa";
import { GiEvilBook, GiWorld } from "react-icons/gi";
import TopUsers from "./TopUsers/TopUsers";
import Bg_Photo from "../components/assets/images/bbblurry2.png";

export const InstructorCard = (props) => {
  return (
    <div className={`box p-5 py-5 rounded-md`}>
      <div className="flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <div className={`${props.color} flex-shrink-0`}>{props.icon}</div>
          <h4 className="text-lg font-semibold text-black">{props.title}</h4>
        </div>
        <p className="text-gray-500 mt-2">{props.desc}</p>
      </div>
    </div>
  );
};

export const Instructor = () => {
  const [pageData, setPageData] = useState(null);
  const [secPageData, setSecPageData] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await fetch(
          "https://notesmania.in/api/theme_setting/youtube-page-setting.php"
        );
        const result = await response.json();
        if (result.success && result.data) {
          setPageData(result.data);
        } else {
          console.error("API returned invalid pageData.");
        }
      } catch (error) {
        console.error("Fetch pageData error:", error);
      }
    };

    fetchPageData();
  }, []);

  useEffect(() => {
    const fetchSecPageData = async () => {
      try {
        const response = await fetch(
          "https://notesmania.in/api/theme_setting/website-settings.php"
        );
        const result = await response.json();
        if (result.success && result.data) {
          setSecPageData(result.data);
        } else {
          console.error("API returned invalid secPageData.");
        }
      } catch (error) {
        console.error("Fetch secPageData error:", error);
      }
    };

    fetchSecPageData();
  }, []);

  if (!pageData || !secPageData) {
    return <div className="text-center py-10">Loading...</div>;
  }

  return (
    <section
      className="instructor mb-16"
      style={{
        backgroundImage: `url(${Bg_Photo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="heading py-12 text-center w-2/3 m-auto md:w-full">
          <h1 className="text-3xl font-semibold text-black">{pageData.title}</h1>
          <span className="text-[14px] mt-2 block">{pageData.bio}</span>
        </div>

        <div className="content grid grid-cols-2 gap-5 md:grid-cols-1">
          <div className="videos rounded-lg overflow-hidden h-72 w-full">
            <iframe
              src={pageData.video1?.replace("watch?v=", "embed/")}
              title="YouTube Video 1"
              className="rounded-t-lg object-cover w-full h-72"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          <div className="videos rounded-lg overflow-hidden h-72 w-full">
            <iframe
              src={pageData.video2?.replace("watch?v=", "embed/")}
              title="YouTube Video 2"
              className="rounded-t-lg object-cover w-full h-72"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="content flex flex-col items-center pt-12">
          {secPageData.pageDetails && (
            <div className="heading text-center w-2/3 md:w-full">
              <h1 className="text-3xl font-semibold text-black">
                {secPageData.pageDetails.title}
              </h1>
              <span className="text-[14px] mt-2 block">
                {secPageData.pageDetails.bio}
              </span>
            </div>
          )}

          {Array.isArray(secPageData.sections) && (
            <div className="content grid grid-cols-4 gap-5 md:grid-cols-2 mt-8">
              {secPageData.sections.map((item) => (
                <InstructorCard
                  key={item.id}
                  color="text-blue-500"
                  icon={
                    <img
                      src={`https://notesmania.in/api/${item.icon}`}
                      alt={item.name}
                      className="w-12 h-12 object-contain"
                    />
                  }
                  title={item.number}
                  desc={item.name}
                />
              ))}
            </div>
          )}

          <div className="content flex flex-col items-center pt-12">
            <TopUsers />
          </div>
        </div>
      </div>
    </section>
  );
};
